
<div class="content-wrapper pt-2"> 
  <section class="content">
   
    <div class="card card-info"  [ngClass]="{'dark-bg' : isDark }">
      <div class="card-header"> Sales Return</div> 
      <form [formGroup]="invoiceForm"  autocomplete="off"  class="form-horizontal">   
      <div class="card-body">   
          
        <div class="row">    
          <div class="col-md-4">
            <div class="form-group">
              <label for="invoiceNo" class="col-form-label">Return No</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-hashtag"></i></span>
                </div>
                <input type="text" [ngClass]="{'dark-input-field' : isDark }" readonly formControlName="invoiceNo" class="form-control field-bg-color" [class.is-invalid]="formErrors.invoiceNo" (blur)="logValidationErrors()" placeholder="Return No">
              </div>
              <span class="text-danger" *ngIf="formErrors.invoiceNo"><small>{{formErrors.invoiceNo}}</small> </span>   
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="invoiceDate" class="col-form-label">Return Date </label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                </div>
                <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="invoiceDate" class="form-control field-bg-color"  [class.is-invalid]="formErrors.invoiceDate" (blur)="logValidationErrors()" placeholder="Return Date">
              </div>
              <span class="text-danger" *ngIf="formErrors.invoiceDate"><small>{{formErrors.invoiceDate}}</small> </span>   
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
                <label for="refNo" class="col-form-label">Invoice Ref No.</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-edit"></i></span>
                  </div>
                  <input [ngClass]="{'dark-input-field' : isDark }" [readonly]="isfieldReadOnly" class="form-control field-bg-color" formControlName="refNo" placeholder="Invoice Ref No.">
                </div>   
              </div>
          </div> 
        </div>


        <div class="row">
          <div class="form-group">
            <input  name="cusId" readonly formControlName="cusId" [(ngModel)]="invoice.cusId" id="cusId"  class="form-control"    type="hidden">
            </div>           
            <div class="col-md-5">
              <div class="form-group">
                <label for="cusName" class="col-form-label">Customer</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fas fa-user"></i></span>
                  </div>
                  <input [ngClass]="{'dark-input-field' : isDark }" type="text" formControlName="cusName" (focusout)="getCustomerDetails()"  [matAutocomplete]="autoCustomer" class="form-control field-bg-color"  [class.is-invalid]="formErrors.cusName" (blur)="logValidationErrors()" placeholder="Customer Name">
                  <mat-autocomplete autoActiveFirstOption  #autoCustomer="matAutocomplete">
                    <mat-option *ngFor="let option of filteredCustomerList | async" [value]="option.CusName">
                      {{option.CusName}}
                    </mat-option>
                  </mat-autocomplete> 
                </div>
                <span class="text-danger" *ngIf="formErrors.cusName"><small>{{formErrors.cusName}}</small> </span>               
              </div>
            </div>
            <div class="col-md-7">
              <div class="form-group">
                <label for="address" class="col-form-label">Address</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-home"></i></span>
                  </div>
                  <input readonly [ngClass]="{'dark-input-field' : isDark }" class="form-control field-bg-color" formControlName="address" [(ngModel)]="invoice.address" id="address" [class.is-invalid]="formErrors.address" (blur)="logValidationErrors()" placeholder="Address">
                </div>
                <span class="text-danger" *ngIf="formErrors.address"><small>{{formErrors.address}}</small> </span>   
              </div>
            </div> 
        </div>
  

        <!-- Invoice Items -->   
        <div class="row"> 
        <div class="col-md-12">
        <table class="table table-sm mt-2 table-bordered" [ngClass]="{'dark-bg' : isDark }">  
          <thead class="thead-light"  [ngClass]="{'dark-input-field' : isDark }" [ngClass]="{'thead-light' : !isDark }">
            <tr>
              <th style="width: 20%"  scope="col">Item Code</th>
              <th style="width: 25%"  scope="col">Description</th>
              <th style="width: 14%"  scope="col" style="text-align: center">UnitPrice</th>
              <th style="width: 5%"  scope="col" style="text-align: center">Qty</th>
              <th style="width: 15%" scope="col" style="text-align: center">Amount</th>
              <th *ngIf="!isHideBtn"></th> 
            </tr>
            </thead>

            <tbody class="ml-1" formArrayName="invoiceItems" *ngFor="let invoiceItem of invoiceForm.get('invoiceItems')['controls']; let i = index">                    
              <tr [formGroupName] = "i" >                      
                <td><input  (focusout)="getItemData(i)" [matAutocomplete]="auto" [readonly]="isfieldReadOnly" [ngClass]="{'dark-input-field' : isDark }" type="text"  class="form-control form-control-sm field-bg-color" formControlName="itemCode" [class.is-invalid]="invoiceItem.get('itemCode').invalid && invoiceItem.get('itemCode').touched">
                  <mat-autocomplete autoActiveFirstOption   #auto="matAutocomplete">
                    <mat-option *ngFor="let option of filteredOptions[i] | async" [value]="option.ItemCode">
                      {{option.ItemCode}}
                    </mat-option>
                  </mat-autocomplete> 
                </td>   
                                   
                  <td><input [ngClass]="{'dark-input-field' : isDark }"   type="text" readonly class="form-control form-control-sm field-bg-color" formControlName="description" [class.is-invalid]="invoiceItem.get('description').invalid && invoiceItem.get('description').touched"></td> 
                  <td><input [ngClass]="{'dark-input-field' : isDark }" [readonly]="isfieldReadOnly" type="text" (keyup)="calEachItemAmount(i)" (focusout)="covertAmountsToMinus(i)" style="text-align: right"  readonly class="form-control form-control-sm field-bg-color" formControlName="unitPrice" [class.is-invalid]="invoiceItem.get('unitPrice').invalid && invoiceItem.get('unitPrice').touched"></td>  
                  <td><input [ngClass]="{'dark-input-field' : isDark }" [readonly]="isfieldReadOnly" type="text" (keyup)="calEachItemAmount(i)" (focusout)="covertAmountsToMinus(i)" style="text-align: right"  readonly class="form-control form-control-sm field-bg-color" formControlName="qty" [class.is-invalid]="invoiceItem.get('qty').invalid && invoiceItem.get('qty').touched"></td>  
                  <td><input [ngClass]="{'dark-input-field' : isDark }"  type="text" style="text-align: right"  readonly class="form-control form-control-sm field-bg-color" formControlName="amount" [class.is-invalid]="invoiceItem.get('amount').invalid && invoiceItem.get('amount').touched"></td>  
                  <td *ngIf="!isHideBtn">
                    <button *ngIf="!isBtnDisabled && invoiceForm.get('invoiceItems').length > 1" class="btn btn-danger btn-sm ml-1 text-white" (click)="removeItemButtonClick(i)" data-toggle="deleteTooltip" data-placement="bottom" title="Delete"><i class="fa fa-close"></i></button>         
                </td>                   
                </tr>                                                         
        </tbody>

            <tfoot *ngIf="!isHideBtn">
              <tr>
                <td colspan="8"><button  [disabled]="isBtnDisabled || invoiceForm.get('invoiceItems').invalid" type="button" class="btn btn-success btn-sm text-white float-right" (click)="addItemButtonClick()"><i class="fa fa-plus"></i> Add</button></td>
              </tr>   
            </tfoot>
        </table> 
      </div> 
    </div>

        <div class="row mt-3 mr-4">
          <div class="col-md-4" *ngIf="showInvoicePmtDetails">
            <div class="form-group">
          <table class="table  table-clear table-sm"  [ngClass]="{'dark-bg' : isDark }">
          <tbody>
            <tr>
              <td colspan="2" class="text-center pt-2"><strong>Credit Note Details</strong></td>                
          </tr> 
           <tr>
              <td  class="pt-2">Status</td>
              <td>{{invoice.status}}</td>
          </tr> 
          <tr>
            <td class="pt-2">Invoice Total</td>
             <td>{{invoice.grandTotal |  number:'1.2-2'}}</td>
          </tr> 
          <tr>
            <td class="pt-2">Paid Amount</td>
             <td>{{invoice.amountPaid |  number:'1.2-2'}}</td>
          </tr> 
          <tr>
            <td class="pt-2">Balance</td>
             <td>{{invoice.balToPay |  number:'1.2-2'}}</td>
          </tr> 
          <tr>
            <td class="pt-2">Created By</td>
             <td>{{invoice.createdBy}}</td>
          </tr>
          </tbody>
        </table>
            </div>
        </div>
      
          <div class="col-md-4"  [class.offset-md-4]='bsClassToShow' [class.offset-md-8]='!bsClassToShow'>
            <table class="table table-clear"  [ngClass]="{'dark-bg' : isDark }">
              <tbody>
              <tr>
              <td class="left">
              <strong>Total</strong>
              </td>
              <td class="text-right">
              <strong>{{invoice.grandTotal | number:'1.2-2'}}</strong>
              </td>
              </tr>
              </tbody>
              </table>
        </div>
      </div>

    
      </div>
      
      <!-- /.card-body -->
        
      <div class="card-footer">
      <button *ngIf="crud_access.create"  type="button" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>
        <button *ngIf="crud_access.create"  type="button" [disabled]="isBtnDisabled"  (click)="saveButtonClick()" class="btn btn-info ml-2">
         <span *ngIf ="showProcessingIndicator" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          Save
        </button>
        <button *ngIf="crud_access.delete"  class="btn btn-danger ml-2" [disabled]="isCancelBtnDisabled" (click)="deleteButtonClick()">Cancel</button>   
        <button class="btn btn-success ml-2" routerLink="../sale-return-list"><i class="fa fa-table p-1"></i>Sale Return List</button>
        <button  *ngIf ="isShowAttachBtn" class="btn btn-primary ml-2" (click)="attachFileButtonClick()"><i class="fa fa-plus p-1"></i>Attach Files</button>

        
        <button (click)="savePDF('print')"  mat-icon-button class="text-info float-right">
          <mat-icon>print</mat-icon>
        </button>
        <button (click)="savePDF('download')"  mat-icon-button class="text-success float-right">
          <mat-icon>cloud_download</mat-icon>
        </button>
        <button (click)="savePDF('open')"  mat-icon-button class="text-dark float-right">
          <mat-icon  [ngClass]="{'dark-bg' : isDark }">preview</mat-icon>
        </button>
      
      </div>

      </form>
    </div>

  </section>

</div> 






